/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import InfoTable from './InfoTable';
import InfoFilter from './InfoFilter';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const infoInventoryBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'inventory',
    url: '/inventory/create'
  },
  {
    label: 'inventory_information',
    active: true
  }
];

const InfoInventory = () => {
  const { t } = useTranslation();
  const [barcodeValue, setBarcodeValue] = useState('');
  const [infoValues, setInfoValues] = useState<any>([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getFilterData, setGetFilterData] = useState({});

  return (
    <div>
      <PageBreadcrumb items={infoInventoryBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('inventory_information')}</h2>
          <ButtonRefresh
            onRefresh={() => queryClient.refetchQueries('GET_PROVIDER_CHECK')}
          />
        </div>

        <InfoFilter
          setBarcodeValue={setBarcodeValue}
          barcodeValue={barcodeValue}
          infoValues={infoValues}
          savedValues={savedValues}
          setSavedValues={setSavedValues}
          setGetFilterData={setGetFilterData}
          getFilterData={getFilterData}
        />
        <InfoTable
          barcodeValue={barcodeValue}
          setInfoValues={setInfoValues}
          getFilterData={getFilterData}
        />
      </div>
    </div>
  );
};

export default InfoInventory;
